// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as QuickViewCard$Showside from "./QuickViewCard.bs.js";
import * as ListPageSlider$Showside from "./ListPageSlider.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function TaggedMediaContent$MediaCard(Props) {
  var shape = Props.shape;
  var fluid = Props.fluid;
  var imageFitToContainerOpt = Props.imageFitToContainer;
  var parentCategory = Props.parentCategory;
  var media = Props.media;
  var imageFitToContainer = imageFitToContainerOpt !== undefined ? imageFitToContainerOpt : false;
  RouterProvider$Showside.useRouter(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var lastModifiedAt = match.config.lastModifiedAt;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onProductClick = match$1.onProductClick;
  var onCategoryClick = match$1.onCategoryClick;
  var onProductClickFromOverlayClick = React.useCallback(function (param) {
    return function (param, product, variant) {
      return Curry._2(onProductClick, product, variant);
    };
  }, [lastModifiedAt]);
  var onQuickViewClick = React.useCallback(function (parentCategory) {
    return Curry.__1(onCategoryClick);
  }, [lastModifiedAt]);
  var onQuickViewClick$1 = React.useMemo(function () {
    var match = Belt_Option.keep(Category$Showside.Link.getCardLink(media), Category$Showside.Link.isNotEmpty);
    if (match !== undefined) {
      return onQuickViewClick;
    }
  }, [onQuickViewClick]);
  var tmp = {
    category: media,
    parentCategory: parentCategory,
    shape: shape,
    fluid: fluid,
    showTitle: false,
    enableViewProductButton: false,
    imageFitToContainer: imageFitToContainer,
    onOverlayProductClick: onProductClickFromOverlayClick
  };
  if (onQuickViewClick$1 !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onQuickViewClick$1);
  }
  return React.createElement(QuickViewCard$Showside.make, tmp);
}
TaggedMediaContent$MediaCard.displayName = "TaggedMediaContent.MediaCard";
var MediaCard = {
  make: TaggedMediaContent$MediaCard
};
function useRenderedTaggedMedia(cardShape, parentCategory) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var lastModifiedAt = match.config.lastModifiedAt;
  var media = React.useMemo(function () {
    return Belt_Option.flatMap(Category$Showside.TaggedMedia.get(parentCategory), function (param) {
      return param.source._0;
    });
  }, [parentCategory, lastModifiedAt]);
  var imageFitToContainer = React.useMemo(function () {
    return Belt_Option.getWithDefault(Belt_Option.map(Category$Showside.TaggedMedia.get(parentCategory), function (param) {
      return param.imageFit === /* FitContain */1;
    }), false);
  }, [parentCategory, lastModifiedAt]);
  var renderCard = React.useCallback(function (index) {
    return function (category, fluid, shape) {
      return React.createElement(TaggedMediaContent$MediaCard, {
        shape: Belt_Option.getWithDefault(shape, cardShape),
        fluid: fluid,
        imageFitToContainer: imageFitToContainer,
        parentCategory: parentCategory,
        media: category,
        key: parentCategory.id + category.id
      });
    };
  }, [media]);
  return React.useMemo(function () {
    return Belt_Option.map(media, function (__x) {
      return Belt_Array.mapWithIndex(__x, renderCard);
    });
  }, [renderCard]);
}
function useInlineTaggedMedia(category) {
  RouterProvider$Showside.useRouter(undefined);
  var cardShape = Category$Showside.CategoryCard.getCardShape(undefined, undefined, category.card);
  var taggedMedia = useRenderedTaggedMedia(cardShape, category);
  return Belt_Option.keep(taggedMedia, function (param) {
    return Caml_obj.equal(Category$Showside.TaggedMedia.getDisplayType(category), /* InlineDisplay */0);
  });
}
var Inline = {
  useInlineTaggedMedia: useInlineTaggedMedia
};
function useSliderTaggedMedia(classNameOpt, cardShape, columns, layout, category) {
  var className = classNameOpt !== undefined ? classNameOpt : "";
  RouterProvider$Showside.useRouter(undefined);
  var taggedMedia = useRenderedTaggedMedia(cardShape, category);
  var gap;
  gap = layout._0.gap;
  var padding;
  padding = layout.TAG === /* SliderLayout */0 ? layout._0.padding : layout._0.padding;
  var maxWidth;
  maxWidth = layout.TAG === /* SliderLayout */0 ? layout._0.maxWidth : layout._0.maxWidth;
  var match = Category$Showside.TaggedMedia.getCardSize(category);
  var taggedMediaCardHeight = match[1];
  var taggedMediaCardWidth = match[0];
  var taggedMediaSlidesPerView = Category$Showside.TaggedMedia.getSlidesPerView(category);
  var renderSlider = function (media) {
    var shape = taggedMediaCardWidth !== undefined && taggedMediaCardHeight !== undefined ? (/* Custom */{
      _0: taggedMediaCardWidth,
      _1: taggedMediaCardHeight
    }) : cardShape;
    var tmp = {
      id: category.id,
      rows: 1,
      children: Belt_Array.map(media, function (f) {
        return Curry._2(f, false, shape);
      }),
      slidesPerView: Belt_Option.getWithDefault(taggedMediaSlidesPerView, columns),
      gap: gap,
      className: className
    };
    if (padding !== undefined) {
      tmp.padding = padding;
    }
    if (maxWidth !== undefined) {
      tmp.maxWidth = maxWidth;
    }
    return React.createElement(ListPageSlider$Showside.make, tmp);
  };
  return Belt_Option.map(Belt_Option.keep(taggedMedia, function (param) {
    return Caml_obj.equal(Category$Showside.TaggedMedia.getDisplayType(category), /* SliderDisplay */1);
  }), renderSlider);
}
var Slider = {
  useSliderTaggedMedia: useSliderTaggedMedia
};
export { MediaCard, useRenderedTaggedMedia, Inline, Slider };
/* react Not a pure module */